// /src/components/core/HeadersAndFooters/FooterButtonsFeed.jsx
// Footer buttons overlay for feed pages
// Buttons: Go to Top (when scrolled)
// Note: Invite Friends moved to SidebarGroups
// A "More" button also lived here (centre, at bottom of content) until 13 August 2026, when it
// was removed — it dispatched ournet:loadMore, which had no listener anywhere in the app, so it
// was a no-op on click. See docs/briefs/2026-08-13-dead-more-controls-removal.md.

import { useState, useEffect } from 'react';
import StandardButton from '../StandardButton';
import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useTranslation } from '../../../i18n/useTranslation';

function FooterButtonsFeed() {
  const { isMobile } = useMediaQuery();
  const { t } = useTranslation('ui');
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const mainContent = document.getElementById('main-feed-content');

    const handleScroll = () => {
      if (!mainContent) return;

      // Show Go to Top if scrolled more than 100px from top
      const mainContentScrolled = mainContent.scrollTop > 100;
      const windowScrolled = window.scrollY > 100;
      setIsScrolled(mainContentScrolled || windowScrolled);
    };

    // Listen to both main content scroll and window scroll
    if (mainContent) {
      mainContent.addEventListener('scroll', handleScroll);
    }
    window.addEventListener('scroll', handleScroll);

    // Check initial scroll position
    handleScroll();

    return () => {
      if (mainContent) {
        mainContent.removeEventListener('scroll', handleScroll);
      }
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleGoToTopClick = () => {
    console.log('Go to Top button clicked');
    // Scroll both the main content grid and the window to top
    const mainContent = document.getElementById('main-feed-content');
    if (mainContent) {
      mainContent.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: isMobile ? 'center' : 'space-between',
      padding: isMobile ? '0 12px' : '0 40px',
      paddingRight: isMobile ? '12px' : '130px', // Account for Help button on right (50px + 40px + 40px spacing) - smaller on mobile
      gap: isMobile ? '8px' : '16px'
    }}>
      {/* Left Side - Empty space for balance (hidden on mobile) */}
      {!isMobile && (
        <div style={{ display: 'flex', gap: '16px' }}>
        </div>
      )}

      {/* Centre spacer — held empty on removal of the dead More button (13 Aug 2026) so the
          space-between layout doesn't shift; see file header. Not rebalanced further — flagged
          in the removal brief's report, not fixed here. */}
      <div style={{ display: 'flex', gap: isMobile ? '8px' : '16px' }} />

      {/* Right Side - Go to Top */}
      <div style={{ display: 'flex', gap: isMobile ? '8px' : '16px' }}>
        {isScrolled && (
          <StandardButton
            variant="action"
            iconName="ArrowUp"
            label={isMobile ? t('top') : t('go_to_top')}
            onClick={handleGoToTopClick}
          />
        )}
      </div>
    </div>
  );
}

export default FooterButtonsFeed;
